/**
 * 推荐游戏 Hook
 * 获取轮播图/热门/最新游戏
 */

import { useQuery } from '@tanstack/react-query';
import { featuredAdapter } from '../adapters';


/**
 * 获取推荐游戏（轮播图用）
 * ⚠️ 降级：使用热度算法
 */
export function useFeatured() {
  return useQuery({
    queryKey: ['featured'],
    queryFn: async () => {
      const result = await featuredAdapter.getFeatured();
      return result;
    },
    staleTime: 5 * 60 * 1000, // 5分钟缓存
  });
}

/**
 * 获取推荐游戏（简化版，返回数据和降级状态）
 */
export function useFeaturedGames(limit: number = 5) {
  const { data, isLoading } = useQuery({
    queryKey: ['featured', limit],
    queryFn: async () => {
      const result = await featuredAdapter.getFeatured();
      return {
        data: result.data.slice(0, limit),
        isDegraded: result.fallback ?? false,
      };
    },
    staleTime: 5 * 60 * 1000,
  });
  
  return {
    data: data?.data ?? [],
    isLoading,
    isDegraded: data?.isDegraded ?? false,
  };
}

/**
 * 获取热门游戏
 */
export function useHotGames(limit: number = 10) {
  return useQuery({
    queryKey: ['hotGames', limit],
    queryFn: async () => {
      const result = await featuredAdapter.getHotGames(limit);
      return result;
    },
    staleTime: 5 * 60 * 1000,
  });
}

/**
 * 获取最新游戏
 */
export function useNewGames(limit: number = 10) {
  return useQuery({
    queryKey: ['newGames', limit],
    queryFn: async () => {
      const result = await featuredAdapter.getNewGames(limit);
      return result;
    },
    staleTime: 5 * 60 * 1000,
  });
}
